angular.module('TetherApp').factory('conversationModalService', [
    '$http',
    '$mdDialog',
    'conversationService',
    'messageService',
    function (
        $http,
        $mdDialog,
        conversationService,
        messageService
    ) {
        let self = this;

        let randomString = function () {
            let result = '';
            let length = 16;
            let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        this.getConversationModal = function(ev, page, participantId, conversationId) {
            self.conversationModalPage = page;
            self.conversationModalParticipantId = participantId;
            self.conversationModalConversationId = conversationId;
            ConversationModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ConversationModalController,
                controllerAs: 'conversationModalController',
                templateUrl: '/conversation/modal/main',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let ConversationModalController = function ($mdDialog) {
            let dCtrl = this;
            this.message = '';
            this.sms_character_limit = 140;
            this.participantMessages = [];
            this.openedReplies = [];
            this.openedBodies = [];
            this.isSending = false;
            this.page = self.conversationModalPage;
            this.participantId = self.conversationModalParticipantId;
            this.conversationId = self.conversationModalConversationId;

            this.hide = function () {
                $mdDialog.hide();
            };

            this.cancel = function () {
                $mdDialog.cancel();
            };

            this.toggleReply = function (message) {
                let openedIndex = this.openedReplies.indexOf(message.id);
                if (openedIndex === -1) {
                    this.openedReplies.push(message.id);
                } else {
                    delete this.openedReplies[openedIndex];
                }

                if (message.type === 's3email' || (message.type === 'widget' && message.subtype === 'email')) {
                    this.subject = 'RE: ' + message.message.subject;
                }
            };

            this.isReplyOpen = function (messageId) {
                return this.openedReplies.indexOf(messageId) > -1;
            }

            this.reply = function (type, messageId) {
                let data = { participant_id: this.participant.Id };
                this.isSending = true;

                if (type === 'sms') {
                    data.shortcode_id = window.shortcode_id;
                    data.message = this.message;
                    data.type = 'sms';
                }

                if (type === 's3email') {
                    data.subject = this.subject;
                    data.message = this.body;
                    data.message_id = messageId;
                    data.type = 's3email';
                }

                messageService.send(data).then(onSend, onError);
            };

            this.toggleBody = function (messageId) {
                let openedBodyIndex = this.openedBodies.indexOf(messageId);
                if (openedBodyIndex === -1) {
                    this.openedBodies.push(messageId);
                } else {
                    delete this.openedBodies[openedBodyIndex];
                }
            }

            this.isBodyOpen = function (messageId) {
                return this.openedBodies.indexOf(messageId) > -1;
            };

            this.setSmsCharacterLimit = function (limit) {
                this.sms_character_limit = limit;
            };

            this.getParticipant = function (participantId) {
                return $http.get('/api/v1/participants/' + participantId + '/' + randomString(), {
                    cache: false,
                    headers: { 'Cache-Control': 'no-cache' }
                }).then(function (response) {
                    return response.data;
                }).then(function (data) {
                    dCtrl.participant = data;
                }, onError);
            };

            this.updateReadStatusForce = function (conversationId) {
                if (conversationId != undefined) {
                    conversationService.updateReadStatus(conversationId, 1)
                        .then(function (data) {
                            // TODO: add optional callback
                        }, onError);
                }
            };

            this.getParticipantMessages = function(page, participantId) {
                messageService.getParticipantMessages(page, participantId, window.shortcode_id)
                    .then(function (data) {
                        self.participantMessages = data.data;
                        self.isDataLoaded = true;
                    }, onError);
            };

            this.getExperiences = function() {
                conversationService.getExperiences()
                    .then(function (data) {
                        self.experiences = data;
                    }, onError);
            };

            this.sendMessage = function () {
                if (this.currentExperience != undefined && this.currentExperience != '') {
                    messageService.sendExperienceRequestEvent(
                        this.participant.Id,
                        this.currentExperience
                    ).then(onSend, onError);
                } else {
                    if (this.message != undefined && this.message != '') {
                        messageService.send({
                            type: 'sms',
                            participant_id: this.participant.Id,
                            shortcode_id: window.shortcode_id,
                            message: this.message
                        }).then(onSend, onError);
                    }
                }
            };

            let onSend = function (data) {
                self.message = '';
                self.subject = '';
                self.body = '';
                self.openedReplies = [];
                self.currentExperience = '';
                self.isSending = false;
                data.forEach(function (message) {
                    self.participantMessages.push(message);
                });
                self.updateSmsCounts();
            };

            let onError = function (reason) {
                // TODO: Display appropriate error message
                self.isSending = false;
            };

            this.updateSmsCounts = function() {
                this.message_length = this.message.length;
                this.message_count = Math.ceil(this.message_length / this.sms_character_limit);
            };

            this.init = function () {
                this.isDataLoaded = false;
                this.getParticipant(participantId);
                this.updateReadStatusForce(conversationId);
                this.getParticipantMessages(page, participantId);
                this.getExperiences();
            };

            this.init();
        };

        return {
            getConversationModal: this.getConversationModal
        }

    }
]);
